<template>
  <div :class="$style.formContainer">
    <LoginCard
      :header="headerText"
    >
      <Alert
        centered
        :message="errorMessage"
      />
      <Credentials
        :action="authURL"
        :form="form"
        :isAdmin="false"
        :isLoading="isLoading"
        :ref="formRef"
        :submit="submit"
        :submitButtonText="submitButtonText"
      />
      <div
        :class="$style.resetPassword"
        ref="resetPassword"
      >
        <span
          :class="$style.resetPasswordLink"
          @click="redirect(resetPasswordRoute)"
        >
          Reset User Password
        </span>
      </div>
    </LoginCard>
  </div>
</template>

<script>
import { LoginConsts } from 'client/util/Constants';
import { UserRoutes } from 'client/routes/RouteGenerator';
import Credentials from 'client/components/forms/Credentials.vue';
import LoginCard from 'client/components/LoginCard.vue';
import api from 'client/api';
import autoFillCredentialsFix from 'client/components/mixins/autoFillCredentialsFix';
import loginResponseHandlers, { loginErrorHandler } from 'client/containers/Login/LoginResponseHandlers';
import loginUtil from 'client/components/mixins/loginUtil';

const { authURLs } = LoginConsts;
const { formRef } = LoginConsts.formElements;
const { user } = LoginConsts.clientType;

export default {
  name: 'ContextLogin',

  mixins: [
    autoFillCredentialsFix,
    loginResponseHandlers,
    loginUtil,
  ],

  props: {
    context: {
      type: String,
      required: true,
    },
    completeRedirectUrl: {
      type: String,
      default: undefined,
    },
    headerText: {
      type: String,
      default: 'Log in to JumpCloud',
    },
    redirectTo: {
      type: String,
      default: '',
    },
    submitButtonText: {
      type: String,
      default: 'login',
    },
  },

  components: {
    LoginCard,
    Credentials,
  },

  data() {
    return {
      authURL: authURLs[user],
      form: {
        email: this.getEmail(),
        password: '',
      },
    };
  },
  created() {
    const { redirectTo } = this;
    // Constants
    this.formRef = formRef;
    this.mfaRoute = UserRoutes.mfa(this.redirectTo);
    this.resetPasswordRoute = UserRoutes.resetPassword;
    this.oauthRedirectUrl = redirectTo ? UserRoutes.oauthRedirectUrl(redirectTo) : undefined;
  },

  methods: {
    getEmail() {
      const { subjectid } = this.$route.query;
      return subjectid ? atob(subjectid) : '';
    },

    async request() {
      const {
        loginSuccessHandler,
        mfaRedirectHandler,
        setErrorMessage,
        redirectTo,
        completeRedirectUrl,
        context,
      } = this;

      if (completeRedirectUrl === undefined || completeRedirectUrl.length === 0) {
        this.isLoading = false;
        // For example: https://sso.jumpcloud.com/saml2/[Nameofapplication]');
        return setErrorMessage(`The ${context} endpoint needs to be included in the URL.`);
      }
      try {
        await api[user].login(this.getCredentialsPayload())
          .finally(() => {
            this.isLoading = false;
          });
      } catch (e) {
        const result = loginErrorHandler(e);

        if (result instanceof Error) {
          return setErrorMessage(result.message);
        }

        return mfaRedirectHandler(result, {
          redirectTo,
          context,
        });
      }

      return loginSuccessHandler(completeRedirectUrl);
    },
  },
};
</script>

<style scoped module>
@import '../../css/login-components.css';
</style>
